import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function FinalCtaSection() {
  return (
    <section className="py-24" data-testid="final-cta-section">
      <div className="max-w-[1200px] mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl bg-gradient-to-br from-orange-500 to-fuchsia-600 p-12 md:p-20 text-center"
        >
          {/* Decorative elements */}
          <div className="absolute top-0 left-0 w-40 h-40 bg-white/5 rounded-full -translate-x-1/2 -translate-y-1/2" />
          <div className="absolute bottom-0 right-0 w-60 h-60 bg-white/5 rounded-full translate-x-1/3 translate-y-1/3" />
          <div className="absolute top-1/2 left-1/4 w-2 h-2 bg-white/20 rounded-full" />
          <div className="absolute top-1/3 right-1/3 w-3 h-3 bg-white/10 rounded-full" />

          <div className="relative z-10">
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white mb-4" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Stop Guessing. Start Predicting.
            </h2>
            <p className="text-base md:text-lg text-orange-100 max-w-xl mx-auto mb-8 leading-relaxed">
              Upload your first ad and get a free neuroscience-powered analysis in under 60 seconds.
            </p>
            <a href="/login?mode=register">
              <Button
                data-testid="cta-final-btn"
                className="bg-white text-orange-600 hover:bg-orange-50 rounded-xl h-13 px-8 text-base font-bold shadow-lg shadow-orange-900/20"
                size="lg"
              >
                Analyze Your First Ad &mdash; Free
                <ArrowRight size={18} className="ml-2" />
              </Button>
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
